import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import { Link, withRouter } from 'react-router-dom';

import mediaWidth from '../../../../../../utils/mediaWidth/mediaWidth';

import Analytics from '../../../../../../services/Analytics';

import form from '../../../../../PopupForm';
import Links from '../../../../../../utils/links';
import FilledButton from '../../../../../../common/FilledButton';
import TextButton from '../../../../../../common/CloseButton/TextButton';
import LogoSvg from '../../../../../../common/LogoSvg';
import { directionsName, getDirectionCheckboxes } from '../../../../../../utils/directionsData';

const open = keyframes`
  100% {
      opacity: 1;
  }
`;

const close = keyframes`
  from {
      opacity: 1;
  }
  to {
      opacity: 0;
  }
`;

class MenuLinks extends Component {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const { openForm, location: { pathname } } = this.props;
        openForm(form, { checkboxes: getDirectionCheckboxes() });
        Analytics.sendEvent(`to Form from mobileMenu, page: ${pathname}`);
    }

    render() {
        const {
            className,
            isClosed,
            onClose,
            onAnimationEnd,
        } = this.props;

        const directions = {
            research: directionsName.RESEARCH,
            design: directionsName.DESIGN,
            launch: directionsName.LAUNCH,
            milestones: 'На каком вы этапе?',
        };

        return (
            <Root
                className={className}
                isClosed={isClosed}
                onAnimationEnd={onAnimationEnd}
            >
                <Header>
                    <LinkBaseLogo to={Links.MAIN} onClick={onClose}>
                        <LogoSvgStyled />
                    </LinkBaseLogo>
                    <TextButtonStyled onClick={onClose} />
                </Header>
                <Wrapper>
                    <LinkDirection to={Links.RESEARCH} onClick={onClose}>
                        {directions.research}
                    </LinkDirection>
                    <LinkDirection to={Links.DESIGN} onClick={onClose}>
                        {directions.design}
                    </LinkDirection>
                    <LinkDirection to={Links.LAUNCH} onClick={onClose}>
                        {directions.launch}
                    </LinkDirection>
                    <LinkDirection to={Links.MILESTONES} onClick={onClose}>
                        {directions.milestones}
                    </LinkDirection>
                    <BaseButtonStyled onClick={this.handleClick}>
                        Обсудить задачу
                    </BaseButtonStyled>
                    <LinkStyled to={Links.TEAM} onClick={onClose}>
                        Команда
                    </LinkStyled>
                    <LinkLast to={Links.CONTACTS} onClick={onClose}>
                        Контакты
                    </LinkLast>
                </Wrapper>
            </Root>
        );
    }
}

const Root = styled.div`
    opacity: 0;
    animation-name: ${({ isClosed }) => (!isClosed ? open : close)};
    animation-duration: ${({ isClosed }) => (!isClosed ? 0.7 : 0.4)}s;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 100%;
    min-width: 328px;
    margin: 0 auto;

    ${mediaWidth.m} {
        max-width: 100%;
        min-width: 683px;
    }

`;

const Header = styled.div`


    ${mediaWidth.m} {
        margin-bottom: 195px;
    }
`;

const TextButtonStyled = styled(TextButton)`
    position: absolute;
    top: 24px;
    right: 16px;

    ${mediaWidth.m} {
        top: 34px;
        right: 48px;
    };
`;

const LinkBase = styled(Link)`
    text-transform: uppercase;
    color: #FFFFFF;
    text-decoration: none;

    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0,0,0,0);

    :active {
        color: rgba(255, 255, 255, 0.64);
    }
`;

const LinkBaseLogo = styled(LinkBase)`
    position: absolute;
    top: 24px;
    left: 16px;

    ${mediaWidth.m} {
        top: 34px;
        left: 48px;
    };
`;

const LogoSvgStyled = styled(LogoSvg)`
    fill: white;
`;

const LinkDirection = styled(LinkBase)`
    font-size: 28px;
    line-height: 26px;

    margin-bottom: 40px;

    ${mediaWidth.m} {
        font-size: 48px;
        line-height: 48px;

        margin-bottom: 56px;
    }
`;

const LinkStyled = styled(LinkBase)`
    font-size: 20px;
    line-height: 26px;

    margin-bottom: 32px;

    ${mediaWidth.m} {
        font-size: 32px;
        line-height: 32px;

        margin-bottom: 48px;
    }
`;

const LinkLast = styled(LinkStyled)`
    margin-bottom: 0px;
`;

const BaseButtonStyled = styled(FilledButton)`
    width: 100%;
    height: 63px;

    text-transform: uppercase;
    color: #0032A0;
    font-size: 16px;
    line-height: 19px;

    background: #FFFFFF;

    margin-bottom: 48px;

    :active {
        background: rgba(255, 255, 255, 0.64);
    }

    :hover {
        background: rgba(255, 255, 255, 0.64);
    }

    ${mediaWidth.m} {
        width: 406px;
        height: 71px;

        font-size: 20px;
        line-height: 23px;

        margin-bottom: 104px;
    }
`;

// export default MenuLinks;
export default withRouter(MenuLinks);
